export const ALTERNATIVES_DRAGGABLE_OPTIONS = {
  animation: 150,
  handle: '.drag-handle',
  ghostClass: 'opacity-50',
} as const;
